import { Environment } from './environment.model';
import { NON_PRODUCTION_NOTICE } from './non-production-notice';

export const environment: Environment = {
  apiUrl: 'https://property-tax-backend.dev.kin.co/api/v1',
  skipDomainVerification: true,
  acceptPayments: false,
  stripePublishableKey:
    'pk_test_51U3iapRwFa4tm4bmxSjhFWtM5MVxkfqzxxkwmaE0iXKbMWCvEqr8frZoru4FYhnzxqR11iNTG8ditoSy8EqAA98J00DUtii2QL',
  signupLandingUrl: 'https://6rvxtlhl-dev.webengine.zesty.io/landing/property-tax/harris-county-tx/',
  dotComApiUrl: 'https://app.kin.haus/api/v1',
  quotingUrl: 'https://welcome.kin.haus',
  fullstoryOrgId: 'YVGQ5',
  isProduction: false,
  nonProductionNotice: NON_PRODUCTION_NOTICE,
};
